import React from "react";
const DevCard = () => {
    return (
        <>
            <div className="col-lg-4 col-md-6 col-sm-6 co-12">
                <div className="_doc_nft_card">
                    <div className="_doc_nft_card_img">
                        <img src="assets/img/doc-nft-card-img03.png" alt="dev" className="_doc_nft_card_img_tag" />
                    </div>

                    <div className="_doc_nft_card_cont">
                        <h3 className="_doc_nft_card_cont_txt">developers</h3>
                        <p className="_doc_nft_card_cont_para">API and contracts</p>
                    </div>
                </div>
            </div>
        </>
    )
}
export default DevCard;